import {
  Alert,
  AlertIcon,
  Button,
  CloseButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  AlertTitle,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useEffect } from "react";
interface Props {
  subadmin: any;
  isOpen: any;
  onClose: any;
  getData: () => void;
}
const SubAdminDelete: React.FC<Props> = ({
  subadmin,
  isOpen,
  onClose,
  getData,
}) => {
  // const { _id } = notification;
  // useEffect(() => {
  //     const findCategory = masterCategory.find((val: Record<string, any>) => val._id === _id);

  //     if (!findCategory) {

  //         onClose();
  //     }
  // }, [_id, masterCategory, onClose]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Sub Admin</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text fontWeight="bold" mb="1rem">
            Are you sure to delete sub admin?
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={onClose}>
            Close
          </Button>
          <Button
            colorScheme="red"
            variant={"outline"}
            mr={3}
            // disabled={busy}
            onClick={() => {
              axios({
                method: "delete",
                url: `${process.env.REACT_APP_BASE_URL}/admin/subadmin/${subadmin._id}`,
              })
                .then((response) => {
                  onClose(); // Optionally close the drawer on submit
                  getData(); // Optionally refresh the data after submit
                })
                .catch((error) => {
                  console.error("API Error:", error);
                  onClose();
                });
            }}
          >
            Submit
          </Button>
        </ModalFooter>
        {/* {message && (
                      <ModalFooter>
                          <Alert status="error">
                              <AlertIcon />
                              <AlertTitle mr={2}>{message}</AlertTitle>
                              <CloseButton position="absolute" right="8px" top="8px" />
                          </Alert>
                      </ModalFooter>
                  )} */}
      </ModalContent>
    </Modal>
  );
};

export default SubAdminDelete;
